import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/index.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/FileUpload.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "create-order no-group-border"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_vm.customerList.length && _vm.isShowCustomerInput ? _c('group', [_c(__unplugin_components_0, {
    staticClass: "customerList",
    attrs: {
      "title": i18n.tc("155"),
      "data": _vm.customerList,
      "format": function (v) {
        return {
          name: v.name,
          value: String(v.fk_t_customer_id)
        };
      }
    },
    model: {
      value: _vm.SendMessage.fk_t_customer_id,
      callback: function ($$v) {
        _vm.$set(_vm.SendMessage, "fk_t_customer_id", $$v);
      },
      expression: "SendMessage.fk_t_customer_id"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("155"))])])], 1) : _vm._e(), _c('div', {
    staticClass: "produce-box box"
  }, [_c('h6', {
    staticClass: "produce-title"
  }, [_vm._v(i18n.tc("226"))]), _vm._l(_vm.SendMessage.customerPro, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "produce-info"
    }, [_c('img', {
      attrs: {
        "src": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png'),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.productName))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(i18n.tc("227") + _vm._s(item.productionSn))])]), _c('div', {
      staticClass: "delBtn",
      on: {
        "click": function ($event) {
          return _vm.SendMessage.customerPro.splice(index, 1);
        }
      }
    }, [_vm._v(i18n.tc("228"))])]);
  }), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.isShowProduct = true;
      }
    }
  }, [_vm._v(i18n.tc("229"))])], 2), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("230"))]), _c('div', {
    staticClass: "box-info",
    on: {
      "click": function ($event) {
        _vm.isAddressListShow = true;
      }
    }
  }, [_c('img', {
    staticClass: "icon-i",
    attrs: {
      "src": "/spa_static_mobile/icon/nav20_24@3x.png"
    }
  }), _c('div', {
    staticClass: "info"
  }, [[_c('div', [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.SendMessage.gpsAddr + _vm.SendMessage.detailAddr || '-'))])])]], 2), _c('img', {
    staticClass: "icon-more",
    attrs: {
      "src": "/spa_static_mobile/icon/rightarrow10_18@3x.png"
    }
  })])]), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("231"))]), _c('div', {
    staticClass: "box-info",
    on: {
      "click": function ($event) {
        _vm.dispatchShow = true;
      }
    }
  }, [_c('img', {
    staticClass: "icon-i",
    attrs: {
      "src": "/spa_static_mobile/icon/nav20_24@3x.png"
    }
  }), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.SendMessage.revised_addr || '-'))]), _c('div', {
    staticClass: "name"
  }, [_vm._v(" " + _vm._s(_vm.SendMessage.revised_linkman || '-') + " : " + _vm._s(_vm.SendMessage.revised_linkman_phone || '-') + " ")])]), _c('img', {
    staticClass: "icon-more",
    attrs: {
      "src": "/spa_static_mobile/icon/rightarrow10_18@3x.png"
    }
  })])]), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("232"))]), _c('x-textarea', {
    staticClass: "smy__textarea",
    attrs: {
      "show-counter": "",
      "name": "detail",
      "placeholder": i18n.tc("233"),
      "max": 500
    },
    model: {
      value: _vm.SendMessage.descri,
      callback: function ($$v) {
        _vm.$set(_vm.SendMessage, "descri", $$v);
      },
      expression: "SendMessage.descri"
    }
  }), _c(__unplugin_components_1, {
    attrs: {
      "hidden-border": "",
      "title": ""
    },
    on: {
      "on-change": function ($event) {
        _vm.SendMessage.imgUrl = $event;
      }
    },
    model: {
      value: _vm.SendMessage.imgUrl,
      callback: function ($$v) {
        _vm.$set(_vm.SendMessage, "imgUrl", $$v);
      },
      expression: "SendMessage.imgUrl"
    }
  })], 1), _c('div', {
    staticClass: "box"
  }, [_c(__unplugin_components_2, {
    attrs: {
      "hidden-border": ""
    },
    on: {
      "on-change": function ($event) {
        _vm.SendMessage.fileUrl = $event.join(',');
      }
    },
    model: {
      value: _vm.SendMessage.fileUrl,
      callback: function ($$v) {
        _vm.$set(_vm.SendMessage, "fileUrl", $$v);
      },
      expression: "SendMessage.fileUrl"
    }
  })], 1), _c('div', {
    staticClass: "box"
  }, [_c(__unplugin_components_3, {
    ref: "customFormList",
    attrs: {
      "data": _vm.fieldList
    },
    on: {
      "on-change": function ($event) {
        _vm.fieldData = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "show-loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.btnLoading ? i18n.tc("234") : i18n.tc("235")) + " ")])], 1)], 1), _c('Dispatch', {
    attrs: {
      "isSendRevised": 1
    },
    on: {
      "on-ok": _vm.dispatchClick
    },
    model: {
      value: _vm.dispatchShow,
      callback: function ($$v) {
        _vm.dispatchShow = $$v;
      },
      expression: "dispatchShow"
    }
  }), _c('AddressList', {
    on: {
      "on-ok": _vm.AddressClick
    },
    model: {
      value: _vm.isAddressListShow,
      callback: function ($$v) {
        _vm.isAddressListShow = $$v;
      },
      expression: "isAddressListShow"
    }
  }), _c('Product', {
    attrs: {
      "hasProduct": _vm.SendMessage.customerPro
    },
    on: {
      "on-ok": function ($event) {
        _vm.SendMessage.customerPro = $event;
      }
    },
    model: {
      value: _vm.isShowProduct,
      callback: function ($$v) {
        _vm.isShowProduct = $$v;
      },
      expression: "isShowProduct"
    }
  }), _c('SelectCustomer', {
    attrs: {
      "list": _vm.customerList
    },
    on: {
      "on-success": _vm.onSelectCustomer
    },
    model: {
      value: _vm.isShowSelectCustomer,
      callback: function ($$v) {
        _vm.isShowSelectCustomer = $$v;
      },
      expression: "isShowSelectCustomer"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };